import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, TextField, MenuItem
} from '@mui/material';

const CancelOrderModal = ({
  open,
  onClose,
  onConfirm,
  currentReason = '',
  onReasonChange,
  disableConfirm = false
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" component="div" sx={{ mb: 2 }}>
          Please select a reason for cancellation:
        </Typography>

        <TextField
          select
          fullWidth
          label="Cancel Reason"
          value={currentReason}
          onChange={(e) => onReasonChange(e.target.value)}
          variant="outlined"
          size="small"
        >
          <MenuItem value="">--Select--</MenuItem>
          <MenuItem value="No Drug">No Drug</MenuItem>
          <MenuItem value="Patient Request">Patient Request</MenuItem>
          <MenuItem value="Inappropriate Request">Inappropriate Request</MenuItem>
          <MenuItem value="Exceeds Plan Limits">Exceeds Plan Limits</MenuItem>
          <MenuItem value="Switched to Generic">Switched to Generic</MenuItem>
        </TextField>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}
        sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
  }}>Cancel</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          //color="primary"
        sx={{
            backgroundColor: '#ec008c',
            color: 'white',
            '&:hover': {
              backgroundColor: '#d5006d',
            },
          }}          
          disabled={disableConfirm || currentReason === ''}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelOrderModal;
